import { useState, useEffect } from 'react';
import axios from 'axios';
import { X } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Default per-type colors used only when the admin didn't pick a custom one.
const DEFAULT_TYPE_BG = {
  promotion:   'linear-gradient(to right, #F97316, #F59E0B)',
  new_service: 'linear-gradient(to right, #A855F7, #EC4899)',
  warning:     'linear-gradient(to right, #EF4444, #F43F5E)',
  info:        'linear-gradient(to right, #3B82F6, #06B6D4)',
};

const AnnouncementBanner = () => {
  const [announcement, setAnnouncement] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/announcements/active`)
      .then((res) => {
        if (!res.data) return;
        const dismissedId = sessionStorage.getItem('dismissed_announcement');
        if (dismissedId !== res.data.id) {
          setAnnouncement(res.data);
        }
      })
      .catch(() => { /* silent */ });
  }, []);

  if (!announcement || dismissed) return null;

  const handleDismiss = () => {
    sessionStorage.setItem('dismissed_announcement', announcement.id);
    setDismissed(true);
  };

  // Resolve background and text color: admin custom values take priority,
  // otherwise fall back to the per-type default gradient.
  const customBg = announcement.background_color;
  const customText = announcement.text_color;
  const bgStyle = customBg
    ? { background: customBg }
    : { background: DEFAULT_TYPE_BG[announcement.announcement_type] || DEFAULT_TYPE_BG.info };
  const textColor = customText || '#FFFFFF';

  return (
    <div
      className="py-3 px-4 relative"
      style={{ ...bgStyle, color: textColor }}
      data-testid="announcement-banner"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-center text-center">
        <div className="flex flex-col sm:flex-row sm:items-center sm:gap-2">
          <span className="font-semibold">{announcement.title}</span>
          {announcement.title && announcement.message && (
            <span className="hidden sm:inline opacity-70">—</span>
          )}
          <span className="text-sm sm:text-base opacity-95">{announcement.message}</span>
        </div>
      </div>

      <button
        onClick={handleDismiss}
        className="absolute right-3 top-1/2 -translate-y-1/2 p-1 hover:bg-white/20 rounded-full transition-colors"
        aria-label="Fermer l'annonce"
        style={{ color: textColor }}
      >
        <X size={18} />
      </button>
    </div>
  );
};

export default AnnouncementBanner;
